import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../../config/supabase';

interface Sale {
  id: string;
  customer_id: string;
  employee_id: string;
  total: number;
  payment_method: string;
  created_at: string;
  items: Array<{
    product_id: string;
    quantity: number;
    price: number;
  }>;
}

interface SalesState {
  items: Sale[];
  loading: boolean;
  error: string | null;
}

const initialState: SalesState = {
  items: [],
  loading: false,
  error: null,
};

export const getSales = createAsyncThunk(
  'sales/getSales',
  async () => {
    const { data, error } = await supabase
      .from('sales')
      .select('*');
    
    if (error) throw error;
    return data;
  }
);

const salesSlice = createSlice({
  name: 'sales',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSales.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSales.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(getSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar vendas';
      });
  },
});

export default salesSlice.reducer; 